import { isSameOrAfter } from './isSameOrAfter';
import { isSameOrBefore } from './isSameOrBefore';

export const isDateWithinValidityPeriod = (
  dateString: string,
  { validFrom, validTo }: { validFrom: string; validTo: string | null }
) => {
  return isSameOrAfter(dateString, validFrom) && (!validTo || isSameOrBefore(dateString, validTo));
};
